import Pagination from 'element-ui/lib/pagination';

import './pagination.scss';

// Adding native <select> element in Pagination component for mobile
/* eslint-disable no-unused-vars */
Pagination.components.Sizes.render = function render(h) {
  return (
    <span class="el-pagination__sizes">
      <el-select
        size="mini"
        class="show-for-medium"
        value={this.$parent.internalPageSize}
        on-input={this.handleChange}>
        {this.pageSizes.map(item => (
          <el-option
            value={item}
            label={`${item} ${this.t('el.pagination.pagesize')}`}></el-option>
        ))}
      </el-select>

      <select
        class="hide-for-medium"
        value={this.$parent.internalPageSize}
        on-input={e => this.handleChange(e.target.value)}>
        {this.pageSizes.map(item => (
          <option
            value={item}
            selected={this.$parent.internalPageSize === item}>
            {`${item} ${this.t('el.pagination.pagesize')}`}
          </option>
        ))}
      </select>
    </span>
  );
};

export default Pagination;
